module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.10095/images/anne-hubspot/anne-hubspot@1x.svg"